import {removeTime} from '../../../utils/date'
import forEach from 'lodash/forEach'

export const SITE_INSPECTION_SEARCH_REQUEST = 'SITE_INSPECTION_SEARCH_REQUEST';
export const SITE_INSPECTION_SEARCH_SUCCESS = 'SITE_INSPECTION_SEARCH_SUCCESS';
export const SITE_INSPECTION_SEARCH_ERROR = 'SITE_INSPECTION_SEARCH_ERROR';
export const SITE_INSPECTION_SEARCH_CLEAR = 'SITE_INSPECTION_SEARCH_CLEAR';


export function getQueryString(params) {
    var result = '';
    if (params.inspection_no) return `inspection_no=${params.inspection_no}&`;
    if (params.work_order_no) return `work_order_no=${params.work_order_no}&`;
    if(params.site_status) {
        if(Array.isArray(params.site_status)) {
            forEach(params.site_status, x => result += `site_status=${x}&`)
        } else {
            result += `site_status=${params.site_status}&`;
        }
    }
    if (params.review_status) result += params.review_status.map(a => `review_status=${a}`).join('&') + '&';
    if (params.review_reason) result += params.review_reason.map(a => `review_reason=${a}`).join('&') + '&';
    if(params.suburb) result += `suburb=${params.suburb}&`;
    if (params.bushfire_abatement !== undefined && params.bushfire_abatement !== null) result += `bushfire_abatement=${params.bushfire_abatement}&`;
    if(params.from_date) result += `from_date=${removeTime(params.from_date)}&`;
    if(params.to_date) result += `to_date=${removeTime(params.to_date)}&`;
    if (params.government_land) result += `government_land=${params.government_land}&`;
    return result;
}

export const search = (params, page=0, limit=20, order='-start_date') => {
    if (params.site_status.length === 0 && !params.inspection_no && !params.work_order_no) {
        return {
            type: SITE_INSPECTION_SEARCH_REQUEST,
            payload: {
                params,
                searching: false
            }
        };
    }
    return {
        type: 'CALL_API',
        types: [SITE_INSPECTION_SEARCH_REQUEST, SITE_INSPECTION_SEARCH_SUCCESS, SITE_INSPECTION_SEARCH_ERROR],
        path: `api/siteinspection/search?${getQueryString(params)}page=${page}&limit=${limit}&order=${order}`,
        payload: {
            params,
            page,
            limit,
            order
        }
    };
};

export const searchParametersChanged = (params) => {
    return {
        type: SITE_INSPECTION_SEARCH_REQUEST,
        payload: {
            params,
            searching: false
        }
    };
};

export const clearSearch = () => {
    return {type: SITE_INSPECTION_SEARCH_CLEAR}
};


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/search.js